"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgInterchangeDoubleMobile = function SvgInterchangeDoubleMobile(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 100 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#interchange-double-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.633 20.711c13.288-5.92 27.079-5.92 40.367 0m0 0c13.288-5.92 27.078-5.92 40.366 0",
    stroke: "#E6F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.052 20.711c-12.05-13.89-24.526-14.761-36.63-2.612M50 20.71C40.34 9.999 30.4 7.43 20.606 11.293",
    stroke: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.786 15.013 6.17 16.142s-.708.404-1.88-.012c-1.17-.417-2.37-.862-2.37-.862s-.25-.133-.467.076c-.216.21.065.393.065.393l1.672 1.6s.342.445.94.425c.6-.02 2.365-.125 2.365-.125s1.208-.084 2.724-.753c1.516-.668 6.922-2.972 6.922-2.972s2.093-.823 1.964-1.308c-.13-.486-1.266-.52-1.824-.428-.559.093-5.062 1.856-5.062 1.856l-4.356-2.2s-.571-.223-.324.161c.248.385 2.743 3.658 2.743 3.658m.905 1.79 1.07 1.405s.32.335.532-.643a76.97 76.97 0 0 1 .39-1.709m71.779-9.096-2.768-.672s-.81-.104-1.494-1.141c-.684-1.038-1.374-2.115-1.374-2.115s-.12-.257-.42-.22c-.298.038-.183.353-.183.353l.372 2.283s.005.562.495.906a158.7 158.7 0 0 0 1.964 1.323s1.015.66 2.628 1.038c1.612.379 7.317 1.792 7.317 1.792s2.167.603 2.356.137c.188-.466-.698-1.177-1.2-1.44-.501-.26-5.159-1.563-5.159-1.563L84.338 3.7s-.323-.521-.356-.066c-.034.456-.011 4.572-.011 4.572m-.354 1.974.008 1.767s.055.46.813-.194c.758-.654 1.338-1.13 1.338-1.13",
    stroke: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.218,
    cy: 20.877,
    r: 1.5,
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 20.877,
    r: 2,
    fill: "#fff",
    stroke: "#007AFF"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "interchange-double-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .711)",
    d: "M0 0h100v24H0z"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgInterchangeDoubleMobile);
var _default = exports["default"] = Memo;